import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {CountryService} from '../../../../translation/Services/Country.service';

@Component({
  selector: 'app-country-overview',
  templateUrl: './country-overview.component.html',
  styleUrls: ['./country-overview.component.scss']
})
export class CountryOverviewComponent implements OnInit {
  public grid: Grid;

  constructor(
    private router: Router,
    private countryService: CountryService
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.country.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.country.dealer_vat',
          prop: 'dealerVat',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter(row) {
            return row + '%';
          }
        },
        <TextColumn>{
          name: 'doctrine.country.customer_vat',
          prop: 'customerVat',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 300,
          valueFormatter(row) {
            return row + '%';
          }
        },
        <TextColumn>{
          name: 'doctrine.country.date_format',
          prop: 'dateFormat',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.country.currency_format',
          prop: 'currencyFormat',
          sortable: false,
          type: TextColumn.type,
          translate: true,

        },
        <TextColumn>{
          name: 'doctrine.country.currency_decimals',
          prop: 'currencyDecimals',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('/back-office/country/' + row.id),
              btnClass: 'ripple light ms-1'
            },
          ]
        }

      ],
      service: this.countryService,
      rememberURL: this.router.url,
      method: 'getCountriesWithVats',
      defaultSort: 'name',
      defaultSortType: 'asc',
      showButton: true,
    };
  }

}
